import { useLayoutEffect, useState } from "react";

import { type OnResizeOptions, onResize } from "~/tools/on-resize";
import { useOnResize } from "~/tools/use-on-resize";

export type UseResizeObserverOptions = Pick<OnResizeOptions<unknown>, "debounce">;

export function useResizeObserver<TElement extends HTMLElement>(
	element: null | undefined | TElement,
	{ debounce }: UseResizeObserverOptions = {},
): null | DOMRectReadOnly {
	const [rect, setRect] = useState<null | DOMRectReadOnly>(null);

	useOnResize((_, { contentRect }) => setRect(contentRect), {
		node: element,
		debounce,
	});

	useLayoutEffect(() => {
		if (element == null) {
			return;
		}

		return onResize((_, { contentRect }) => setRect(contentRect), {
			node: element,
			debounce,
		});
	}, [element, debounce]);

	return rect;
}
